export enum NavigationUiTypeEnum {
  full = 'FULL',
  minimal = 'MINIMAL'
}
